// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".media {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n}\n.media .header-img-box-list {\n  margin-top: 20px;\n  width: 120px;\n  margin-left: 20px;\n  height: 120px;\n  border: 1px dashed #ccc;\n  border-radius: 20px;\n  text-align: center;\n  line-height: 180px;\n  cursor: pointer;\n}", ""]);
// Exports
module.exports = exports;
